import { render, staticRenderFns } from "./TextBlockModal.vue?vue&type=template&id=cfacae58"
import script from "./TextBlockModal.vue?vue&type=script&lang=js"
export * from "./TextBlockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports